import {Injectable} from '@angular/core';
import {products} from '../var/constants';
import {EventsService} from "./events.service";

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  selectedProductId = 'LB';

  constructor(private events: EventsService) {
  }

  getSelectedProductId(): string {
    return this.selectedProductId;
  }

  setSelectedProductId(productId: string) {
    this.selectedProductId = productId;
    this.events.publish('product-changed', {productId});
  }

  getProductName(productId: string): string | undefined {
    const productType = products.find(type => type.id === productId);
    return productType?.name;
  }
}
